(() => {
  const MOBILE_BREAKPOINT = 767;
  const initialized = new WeakMap();

  class HCCollectionsNav {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.nav = wrapper.querySelector('[data-hc-collections-nav]');
      this.prevButton = wrapper.querySelector('[data-hc-collections-nav-prev]');
      this.nextButton = wrapper.querySelector('[data-hc-collections-nav-next]');
      this.items = Array.from(wrapper.querySelectorAll('[data-hc-collections-nav-item]'));
      this.activeItem = wrapper.querySelector('.hc-nav-active')?.closest('[data-hc-collections-nav-item]') || null;

      if (!this.nav || !this.prevButton || !this.nextButton) return;

      this.handleResize = this.handleResize.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handlePrevClick = this.handlePrevClick.bind(this);
      this.handleNextClick = this.handleNextClick.bind(this);

      this.prevButton.addEventListener('click', this.handlePrevClick);
      this.nextButton.addEventListener('click', this.handleNextClick);
      this.nav.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);

      this.handleResize();
    }

    isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    getVisibleItems() {
      return 1;
    }

    getScrollAmount() {
      const item = this.items[0];

      if (!item) {
        return this.nav.clientWidth * 0.8;
      }

      const itemStyles = window.getComputedStyle(item);
      const marginLeft = parseFloat(itemStyles.marginLeft || '0') || 0;
      const marginRight = parseFloat(itemStyles.marginRight || '0') || 0;
      return item.getBoundingClientRect().width + marginLeft + marginRight;
    }

    scrollActiveItemIntoView() {
      if (!this.isMobile() || !this.activeItem) return;

      const itemOffset = this.activeItem.offsetLeft;
      const itemWidth = this.activeItem.offsetWidth;
      const targetScrollLeft = Math.max(
        0,
        itemOffset - ((this.nav.clientWidth - itemWidth) / this.getVisibleItems())
      );

      this.nav.scrollTo({ left: targetScrollLeft, behavior: 'auto' });
    }

    handlePrevClick() {
      this.nav.scrollBy({ left: -this.getScrollAmount(), behavior: 'smooth' });
    }

    handleNextClick() {
      this.nav.scrollBy({ left: this.getScrollAmount(), behavior: 'smooth' });
    }

    handleResize() {
      const mobile = this.isMobile();
      this.wrapper.classList.toggle('is-mobile-slider', mobile);

      if (!mobile) {
        this.nav.scrollLeft = 0;
      } else {
        this.scrollActiveItemIntoView();
      }

      this.updateButtons();
    }

    handleScroll() {
      this.updateButtons();
    }

    updateButtons() {
      const mobile = this.isMobile();
      const hasOverflow =
        this.items.length > this.getVisibleItems() &&
        this.nav.scrollWidth > this.nav.clientWidth + 1;
      const showButtons = mobile && hasOverflow;

      this.prevButton.hidden = !showButtons;
      this.nextButton.hidden = !showButtons;

      if (!showButtons) {
        this.prevButton.disabled = true;
        this.nextButton.disabled = true;
        return;
      }

      const maxScrollLeft = this.nav.scrollWidth - this.nav.clientWidth;
      this.prevButton.disabled = this.nav.scrollLeft <= 1;
      this.nextButton.disabled = this.nav.scrollLeft >= maxScrollLeft - 1;
    }
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-hc-collections-nav-wrapper]').forEach((wrapper) => {
      if (!initialized.has(wrapper)) {
        initialized.set(wrapper, new HCCollectionsNav(wrapper));
      } else {
        initialized.get(wrapper).handleResize();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
